import { render, staticRenderFns } from "./consumptionComponent.vue?vue&type=template&id=cc1b1c30&scoped=true&"
import script from "./consumptionComponent.vue?vue&type=script&lang=js&"
export * from "./consumptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./consumptionComponent.vue?vue&type=style&index=0&id=cc1b1c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b1c30",
  null
  
)

export default component.exports